import { CartItem } from '@softapps/wws/pos-core';


export enum CartServiceErrorType {
  QuantityNotAllowed,
  DiscountNotAllowed,
  PriceNotAllowed,
  UpdateCartItemFailed,
}

export interface CartServiceErrorParams {
  type: CartServiceErrorType;
  error?: Error | unknown;
  item?: CartItem;
}

export class CartServiceError extends Error {
  constructor(public params: CartServiceErrorParams) {
    super();
  }

  description(): string {
    switch (this.params.type) {
      case CartServiceErrorType.QuantityNotAllowed:
        return 'Es darf keine Menge kleiner als 1 eingegeben werden!';
      case CartServiceErrorType.DiscountNotAllowed:
        return 'Diesen Rabatt darf nicht hinzugefügt werden!';
      case CartServiceErrorType.PriceNotAllowed:
        return 'Es darf nur Preis größer als 0 eingegeben werden!';
      case CartServiceErrorType.UpdateCartItemFailed:
        return 'Die Position konnte nicht aktualisiert werden!';
      default:
        return 'Es ist ein unbekannter Fehler aufgetreten!';
    }
  }
}

export const CartServiceErrors = {
  quantityNotAllowed() {
    return new CartServiceError({
      type: CartServiceErrorType.QuantityNotAllowed,
    });
  },
  discountNotAllowed() {
    return new CartServiceError({
      type: CartServiceErrorType.DiscountNotAllowed,
    });
  },
  priceNotAllowed() {
    return new CartServiceError({
      type: CartServiceErrorType.PriceNotAllowed,
    });
  },
  updateCartItemFailed(error?: Error | unknown) {
    return new CartServiceError({
      type: CartServiceErrorType.UpdateCartItemFailed,
      error: error ?? undefined,
    });
  },
};
